import { Phone, MapPin, Clock, Car, Navigation } from "lucide-react";
import { BUSINESS } from "../data/site";

export default function Location() {
    return (
        <>
            <section className="relative overflow-hidden">
                <div className="hero-glow" />
                <div className="relative max-w-7xl mx-auto px-5 lg:px-10 py-20 lg:py-24">
                    <div className="text-xs uppercase tracking-[0.22em] text-blue-600 font-semibold">Location</div>
                    <h1 className="mt-3 font-display font-extrabold text-slate-900 text-4xl sm:text-5xl tracking-tight leading-[1.05] max-w-3xl">
                        Find us in the heart of Glendale.
                    </h1>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-5 lg:px-10 pb-20 grid lg:grid-cols-12 gap-8">
                <div className="lg:col-span-8 rounded-3xl overflow-hidden premium-shadow">
                    <iframe title="EG Wireless location" src={BUSINESS.mapsEmbed} className="w-full h-[520px] border-0" loading="lazy" />
                </div>
                <div className="lg:col-span-4 space-y-5">
                    <div className="bg-white rounded-3xl border border-slate-100 premium-shadow p-7">
                        <Item icon={<MapPin className="w-5 h-5 text-blue-600" />} title="Address">
                            {BUSINESS.address}<br /><span className="text-slate-500 text-sm">Inside {BUSINESS.locatedInside}</span>
                        </Item>
                        <Item icon={<Phone className="w-5 h-5 text-blue-600" />} title="Phone">
                            <a href={`tel:${BUSINESS.phoneRaw}`} className="hover:underline">{BUSINESS.phone}</a>
                        </Item>
                        <Item icon={<Clock className="w-5 h-5 text-blue-600" />} title="Hours">
                            <ul className="text-sm space-y-1 text-slate-600">
                                <li className="flex justify-between"><span>Mon – Fri</span><span>12:00 PM – 5:00 PM</span></li>
                                <li className="flex justify-between"><span>Saturday</span><span>12:00 PM – 4:00 PM</span></li>
                                <li className="flex justify-between"><span>Sunday</span><span>12:00 PM – 4:00 PM</span></li>
                            </ul>
                        </Item>
                        <Item icon={<Car className="w-5 h-5 text-blue-600" />} title="Parking" last>
                            <span className="text-sm text-slate-600">Free parking available at the 7-Eleven Plaza.</span>
                        </Item>
                    </div>
                    <div className="flex flex-col gap-3">
                        <a href={`tel:${BUSINESS.phoneRaw}`} data-testid="location-call-btn" className="inline-flex items-center justify-center gap-2 h-12 rounded-full bg-slate-900 text-white font-semibold hover:bg-slate-800 transition">
                            <Phone className="w-4 h-4" /> Call {BUSINESS.phone}
                        </a>
                        <a href={BUSINESS.mapsDirections} target="_blank" rel="noreferrer" data-testid="location-directions-btn" className="inline-flex items-center justify-center gap-2 h-12 rounded-full bg-blue-50 text-blue-700 font-semibold hover:bg-blue-100 transition">
                            <Navigation className="w-4 h-4" /> Get Directions
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
}

function Item({ icon, title, children, last }) {
    return (
        <div className={`flex gap-4 ${last ? "" : "pb-5 mb-5 border-b border-slate-100"}`}>
            <div className="h-10 w-10 rounded-xl bg-blue-50 grid place-items-center flex-shrink-0">{icon}</div>
            <div className="flex-1">
                <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">{title}</div>
                <div className="mt-1 text-slate-900">{children}</div>
            </div>
        </div>
    );
}
